/* eslint-disable max-lines-per-function */
import { SagaIterator } from 'redux-saga';
import { all, call } from 'redux-saga/effects';
import CauHinhDiaChiSaga from 'redux/cauHinhDiaChi/saga';
import QuanLyThanhToanSaga from 'redux/quanLyThanhToan/saga';
import ThongTinTaiKhoanSaga from 'redux/thongTinTaiKhoan/saga';
import TaoDonSaga from 'redux/taoDon/saga';
import KhieuNaiSaga from 'redux/khieuNai/saga';
import QuanLyDonHangSaga from 'redux/QuanLyDonHang/saga';
import QuanLyTienHangSaga from 'redux/quanLyTienHang/saga';
import UploadFileSaga from 'redux/UploadFile/saga';
import ThongTinDonhangSaga from 'redux/ThongTinDonhang/saga';
import PrintOrderSaga from 'redux/printOrder/saga';
import ThongBaoSaga from 'redux/thongBao/saga';

export default function* rootSagas(): SagaIterator {
  yield all([
    call(CauHinhDiaChiSaga),
    call(QuanLyThanhToanSaga),
    call(ThongTinTaiKhoanSaga),
    call(TaoDonSaga),
    call(KhieuNaiSaga),
    call(QuanLyDonHangSaga),
    call(QuanLyTienHangSaga),
    call(UploadFileSaga),
    call(ThongTinDonhangSaga),
    call(PrintOrderSaga),
    call(ThongBaoSaga),
  ]);
}
